import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../store/actions";

const AutoLogout = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    let timeout;

    const resetTimer = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            handleLogout();
        }, 1000000); // 10 seg de inactividad
    };

    const handleLogout = () => {
        alert("Sesión cerrada por inactividad.");
    
        // Petición al backend para cerrar sesión
       // await fetch("/api/logout", { method: "POST", credentials: "include" });
    
        dispatch(logoutUser()); // Cierra sesión en Redux
        history.push("/login"); // Redirige al login
    };

    useEffect(() => {
        // Eventos para detectar actividad del usuario
        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("keydown", resetTimer);
        window.addEventListener("click", resetTimer);
        window.addEventListener("scroll", resetTimer);

        resetTimer(); // Iniciar temporizador

        return () => {
            clearTimeout(timeout);
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            window.removeEventListener("click", resetTimer);
            window.removeEventListener("scroll", resetTimer);
        };
    }, []);

    return null; // No renderiza nada, solo maneja la inactividad
};

export default AutoLogout;
